import React from 'react';
import { FormGroup, Col, Row, Input } from 'reactstrap';
import { FastField, ErrorMessage } from 'formik';

import { WhitePanel } from '../../../components';

const ContactPerson = () => (
  <WhitePanel>
    <h2>
      CONTACT PERSON / CARD HOLDER DETAILS <small />
    </h2>
    <Row className="contact-person">
      <CustomField name="firstName" title="First Name" placeholder="Enter First Name" />
      <CustomField name="lastName" title="Last Name" placeholder="Enter Last Name" />
      <CustomField
        type="tel"
        placeholder="Enter Mobile No. +1-2025550107"
        name="contactMobile"
      />
      <CustomField type="email" placeholder="Enter Email Address" name="contactEmail" smallLabel="(Flight Details will be sent to this email)" />
    </Row>
  </WhitePanel>
);

export default ContactPerson;

type CustomFieldProps = {
  name: string,
  placeholder: string,
  type: string,
  smallLabel: string,
};

const CustomField = ({
  name,
  placeholder = '',
  type = 'text',
  smallLabel,
}: CustomFieldProps) => (
  <Col md="3">
    <FormGroup>
      <FastField name={name}>
        {({ form, field }) => {
          const { setFieldValue, /* errors, touched */ } = form;
          const { name, value } = field;

          return (
            <React.Fragment>
              <Input
                name={name}
                value={value}
                placeholder={placeholder}
                id={name}
                // invalid={touched[name] && errors[name]}
                onChange={e => {
                  const { value } = e.target;
                  const isName = name === 'firstName' || name === 'lastName';

                  setFieldValue(name, value);
                  if (isName) setFieldValue(`passengerDetails[0].${name}`, value);
                }}
              />
              {smallLabel && <small>{smallLabel}</small>}
            </React.Fragment>
          );
        }}
      </FastField>
      <ErrorMessage name={name}>
        {error => <div className="error">{error}</div>}
      </ErrorMessage>
    </FormGroup>
  </Col>
);



// WEBPACK FOOTER //
// ./src/screens/Flights/PassengerDetails/ContactPerson.js